// extracted by mini-css-extract-plugin
module.exports = {"root":"ConsentHeader_root__nbTzD","name":"ConsentHeader_name__1aWhe","birthday":"ConsentHeader_birthday__3lZau","skeleton":"ConsentHeader_skeleton__19-pI"};